import React from 'react';

import ProductListContainer from '../../containers/productmng/ProductListContainer';

const ProductListPage = () => {
  return <ProductListContainer />;
};

export default ProductListPage;
